export class CarouselItem {
  image = '';
  title = '';
  description = '';
  buttonLabel = '';
  buttonAction = '';
}
